var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 80,
    viewBox: "0 0 622 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 190.434L622 -126M1.00001 190.434L622 -103.357M1.00001 190.434L622 -80.7143M1.00001 190.434L622 -58.0714M1.00001 190.434L622 -35.4286M1.00001 190.434L622 -12.7857M1.00001 190.434L622 9.85715M1.00001 190.434L622 32.5M1.00001 190.434L622 55.1429M1.00001 190.434L622 77.7857M1.00001 190.434L622 100.429M1.00001 190.434L622 123.071M1.00001 190.434L622 145.714M1.00001 190.434L622 168.357M1.00001 190.434L622 191",
    stroke: "#45464B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRays);
export default __webpack_public_path__ + "static/media/rays.52e7c2938f11b9ef4b9038df1c7a74d6.svg";
export { ForwardRef as ReactComponent };